import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from '../layouts/RootLayout';
import { NavigableLayout } from '../layouts/NavigableLayout';

// Lazy-loaded page components
import { ConfigListPage } from '../pages/configs/ConfigListPage';
import { ConfigDetailPage } from '../pages/configs/ConfigDetailPage';
import { ConfigCreatePage } from '../pages/configs/ConfigCreatePage';
import { ConfigEditPage } from '../pages/configs/ConfigEditPage';
import { PendingDeletionsPage } from '../pages/configs/PendingDeletionsPage';
import { JourneyView } from '@features/journey/components/JourneyView';

export function createRouter() {
  return createBrowserRouter([
    {
      element: <RootLayout />,
      children: [
        {
          element: <NavigableLayout />,
          children: [
            { path: '/', element: <ConfigListPage /> },
            { path: '/journey', element: <JourneyView /> },
            { path: '/configs/:configId', element: <ConfigDetailPage /> },
            { path: '/configs/new', element: <ConfigCreatePage /> },
            { path: '/configs/:configId/edit', element: <ConfigEditPage /> },
            { path: '/pending-deletions', element: <PendingDeletionsPage /> },
          ],
        },
      ],
    },
  ]);
}
